import TherapySideApiService from "./utils/TherapyApi";

import type {
  BreaksApi,
  BreaksApiQuery,
  BreakReasonsApi,
  CreateBreakApiQuery,
  BreakApi,
} from "@/Modules/Models/Api/Breaks";

import { OrderingParams } from "@/Modules/Models/Api/Breaks";

class SessionsApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  createBreak(
    customerUuid: string,
    reasonUuid: string,
    startAt: number,
    duration: number,
    comment?: string
  ): Promise<BreakApi> {
    return this.ApiService.post<CreateBreakApiQuery, BreakApi>({
      endpoint: "v1.0/breaks",
      body: {
        customer_uuid: customerUuid,
        reason_uuid: reasonUuid,
        start_at: startAt,
        duration,
        comment,
      },
    });
  }

  getBreaks(customerUuid: string): Promise<BreaksApi> {
    return this.ApiService.get<BreaksApiQuery, BreaksApi>({
      endpoint: "v1.0/breaks",
      params: {
        customer_uuid: customerUuid,
        ordering: `-${OrderingParams.START_AT}`,
      },
    });
  }

  getReasons(): Promise<BreakReasonsApi> {
    return this.ApiService.get<void, BreakReasonsApi>({
      endpoint: "v1.0/breaks/reasons",
    });
  }

  deleteBreak(breakUuid: string): Promise<void> {
    return this.ApiService.delete<void, void>({
      endpoint: `v1.0/breaks/${breakUuid}`,
    });
  }
}

export default SessionsApiConnector;
